import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../services/api';
import './Notice.css';

const Notice = () => {
	const [notices, setNotices] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;

	useEffect(() => {
		fetchNotices();
	}, []);

	const fetchNotices = async () => {
		try {
			setLoading(true);
			setError(null);
			
			const response = await fetch(`${API_BASE_URL}/products/notices/`);
			
			if (!response.ok) {
				throw new Error(`HTTP ${response.status}`);
			}
			
			const data = await response.json();
			
			let noticeList = [];
			
			if (Array.isArray(data)) {
				noticeList = data;
			} else if (data && Array.isArray(data.results)) {
				noticeList = data.results;
			}
			
			// 고정 공지 먼저, 나머지는 최신순
			const pinned = noticeList.filter(n => n.is_pinned);
			const normal = noticeList.filter(n => !n.is_pinned);
			
			setNotices([...pinned, ...normal]);
			
		} catch (error) {
			console.error('❌ 공지사항 로딩 실패:', error);
			setError(error.message || '공지사항을 불러올 수 없습니다.');
			setNotices([]);
		} finally {
			setLoading(false);
		}
	};

	// 고정 공지와 일반 공지 분리
	const pinnedNotices = notices.filter(n => n.is_pinned);
	const normalNotices = notices.filter(n => !n.is_pinned);
	
	// 페이지네이션 (일반 공지만)
	const totalPages = Math.ceil(normalNotices.length / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const currentNotices = normalNotices.slice(startIndex, startIndex + itemsPerPage);

	const handlePageChange = (page) => {
		setCurrentPage(page);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	if (loading) {
		return (
			<div className="notice-container">
				<div className="notice-loading">
					<p>공지사항을 불러오는 중...</p>
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className="notice-container">
				<div className="notice-error">
					<p>{error}</p>
					<button onClick={fetchNotices}>다시 시도</button>
				</div>
			</div>
		);
	}

	return (
		<div className="notice-container">
			<h1>📢 공지사항</h1>
			
			{notices.length === 0 ? (
				<div className="notice-empty">
					<p>등록된 공지사항이 없습니다.</p>
				</div>
			) : (
				<>
					<div className="notice-list">
						{/* 고정 공지 */}
						{pinnedNotices.map((notice) => (
							<Link 
								to={`/notice/${notice.id}`} 
								key={notice.id} 
								className="notice-item pinned"
							>
								<span className="notice-num">📌</span>
								<span className="notice-title">{notice.title}</span>
								<span className="notice-date">
									{new Date(notice.created_at).toLocaleDateString('ko-KR')}
								</span>
							</Link>
						))}
						
						{/* 일반 공지 */}
						{currentNotices.map((notice, index) => (
							<Link 
								to={`/notice/${notice.id}`} 
								key={notice.id} 
								className="notice-item"
							>
								<span className="notice-num">
									{normalNotices.length - startIndex - index}
								</span>
								<span className="notice-title">{notice.title}</span>
								<span className="notice-date">
									{new Date(notice.created_at).toLocaleDateString('ko-KR')}
								</span>
							</Link>
						))}
					</div>
					
					{/* 페이지네이션 */}
					{totalPages > 1 && (
						<div className="notice-pagination">
							<button
								onClick={() => handlePageChange(1)}
								disabled={currentPage === 1}
							>
								처음
							</button>
							<button
								onClick={() => handlePageChange(currentPage - 1)}
								disabled={currentPage === 1}
							>
								이전
							</button>
							
							{[...Array(totalPages)].map((_, i) => (
								<button
									key={i + 1}
									onClick={() => handlePageChange(i + 1)}
									className={currentPage === i + 1 ? 'active' : ''}
								>
									{i + 1}
								</button>
							))}
							
							<button
								onClick={() => handlePageChange(currentPage + 1)}
								disabled={currentPage === totalPages}
							>
								다음
							</button>
							<button
								onClick={() => handlePageChange(totalPages)}
								disabled={currentPage === totalPages}
							>
								마지막
							</button>
						</div>
					)}
				</>
			)}
		</div>
	);
};

export default Notice;